import React from 'react';
import AdminLayout from './AdminLayout';
import QuoteBuilderPage from '../QuoteBuilderPage';
import { Receipt } from 'lucide-react';

/**
 * In-Store Quote — staff use the same quote builder as customers but the
 * final step swaps Stripe deposit for a "Mark Paid In-Store" action that
 * runs the full quote→order conversion (order created, customer portal
 * account, welcome email, Prometheus sync) without taking a real payment.
 *
 * Use case: customer is standing at the counter and pays via Shift4/cash/check.
 * Staff records the tender as a label only.
 */
const AdminInStoreQuote = () => {
  return (
    <AdminLayout>
      <div className="bg-[#FDF6E9] border-b border-[#F5A623]/30 px-6 py-3 flex items-center gap-3">
        <Receipt className="w-5 h-5 text-[#F5A623]" />
        <div>
          <p className="text-sm font-bold text-[#1B3A5C]">In-Store Quote Mode</p>
          <p className="text-xs text-gray-600">Build a quote with the customer present. Final step: mark paid in-store (no Stripe).</p>
        </div>
      </div>
      <QuoteBuilderPage inStoreMode={true} />
    </AdminLayout>
  );
};

export default AdminInStoreQuote;
